/**
 * Notification Zod schemalar
 *
 * Kanonik:
 *   - Type: LOW_STOCK, NEW_SALE, DEBT_OVERDUE, CUSTOMER_BIRTHDAY, SYSTEM
 *   - In-app (DB) + Telegram parallel yuboriladi
 *   - data: JSONB payload (productId, orderId, customerId, ...)
 */
import { z } from 'zod';
import { uuidSchema } from './common.schema.js';
// ─── Notification type enum ──────────────────────────────────────
export const notificationTypeEnum = z.enum([
    'LOW_STOCK',
    'NEW_SALE',
    'DEBT_OVERDUE',
    'CUSTOMER_BIRTHDAY',
    'SYSTEM',
]);
// ─── Create notification (server tomoni — foydalanuvchi ishlatmaydi) ─
export const createNotificationSchema = z.object({
    userId: uuidSchema,
    type: notificationTypeEnum,
    title: z.string().min(1).max(200),
    message: z.string().min(1).max(500),
    data: z.record(z.unknown()).optional(),
});
// ─── Notification query ──────────────────────────────────────────
export const notificationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(200).default(50),
    isRead: z.coerce.boolean().optional(),
    type: notificationTypeEnum.optional(),
});
// ─── Telegram send (qo'l bilan yuborish — admin test uchun) ─────
export const telegramSendSchema = z.object({
    storeId: uuidSchema,
    text: z.string().min(1).max(4096),
    parseMode: z.enum(['Markdown', 'HTML']).optional(),
});
//# sourceMappingURL=notification.schema.js.map